import {Injectable} from '@angular/core';
import {Filter, EntityTypeFilter} from "../models/filter";
import {BehaviorSubject} from "rxjs";
import { StrategicPillar } from './strategic-pillar.service';
import { UserAudienceResponse } from './audience.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private filterSubject = new BehaviorSubject<Filter>(new Filter())
  filterData = this.filterSubject.asObservable()

  clearFilters(withGlobal: boolean){
    const newFilter = new Filter()
    if(!withGlobal){
      newFilter.global = this.filterSubject.value.global
    }
    this.filterSubject.next(newFilter)
  }

  updateGlobalSearch(search: string){
    const newFilter = this.filterSubject.value
    newFilter.global = search
    this.filterSubject.next(newFilter)
  }

  updateFilters(filters: Filter) {
    const newFilters = filters

    newFilters.timespan.start.setHours(0, 0, 0, 0)
    newFilters.timespan.end.setHours(23, 59, 59, 999)

    this.filterSubject.next(newFilters)
  }

  /**
   * Toggle entity type filter
   * If entityType is already selected, remove it
   * If not selected, add it
   */
  toggleEntityType(entityType: EntityTypeFilter) {
    const currentFilter = this.filterSubject.value;
    const newFilter = Object.assign(new Filter(), currentFilter);
    
    const index = newFilter.entityTypes.indexOf(entityType);
    if (index > -1) {
      // Remove if already selected
      newFilter.entityTypes.splice(index, 1);
    } else {
      // Add if not selected
      newFilter.entityTypes.push(entityType);
    }
    
    this.filterSubject.next(newFilter);
  }

  /**
   * Update strategic pillars filter
   */
  updateStrategicPillars(pillars: StrategicPillar[]) {
    const currentFilter = this.filterSubject.value;
    const newFilter = Object.assign(new Filter(), currentFilter);
    newFilter.strategicPillars = pillars;
    this.filterSubject.next(newFilter);
  }

  /**
   * Update audiences filter
   */
  updateAudiences(audiences: UserAudienceResponse[]) {
    const currentFilter = this.filterSubject.value;
    const newFilter = Object.assign(new Filter(), currentFilter);
    newFilter.audiences = audiences;
    this.filterSubject.next(newFilter);
  }
}
